<template>
  <div>
    <el-container>
      <el-header>
        <div>
          <router-link to="/index">
            <img class="icon" :src="logoUlr" />
          </router-link>
        </div>
        <div>
          <el-button type="danger" size="mini" @click="exit">退出</el-button>
          <img style="width:40px;border-radius:50%;" class="toux" :src="avatar" />
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px">
          <el-menu
            :default-active="active"
            class="el-menu-vertical-demo"
            background-color="#fff"
            active-text-color="#303133"
            :unique-opened="true"
          >
            <el-submenu :index="item.id + ''" v-for="(item,index) in cateList" :key="index">
              <template slot="title">
                <div @click="queryProduct(item.id)">
                  <i class="el-icon-s-help"></i>
                  <span>{{item.name}}</span>
                </div>
              </template>
              <el-menu-item-group v-loading="loading">
                <el-menu-item
                  :index="item.id + '-' + item1.product_id"
                  v-for="(item1,index1) in productList "
                  :key="index1"
                  @click="go(item1.product_id)"
                >
                  <i class="el-icon-help"></i>
                  {{item1.product_name}}
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <div class="navitems-group">
      <ul class="clearfix" v-if="JSON.stringify(headerList)!='{}'">
        <li v-for="(item,index) in headerList" class="m_item" :key="index">
          <a href="javascript:;" v-if="item.remark===''">{{item.title}}</a>
          <a
            v-else-if="item.remark.includes('http')"
            :href="item.remark"
            target="_blank"
          >{{item.title}}</a>
          <router-link v-else :to="item.remark">{{item.title}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      avatar: '',
      //   分类
      cateList: [],
      //   产品
      productList: [],
      loading: false,
      headerList: {},
      logoUlr: '',
      active: ''
    }
  },
  created() {
    if (window.localStorage.getItem('u')) {
      let u = window.localStorage.getItem('u')
      this.avatar = JSON.parse(u).avatar
    }
    this.queryInfo()
    this.queryMenu()
    this.queryList()
  },
  methods: {
    async queryInfo() {
      const { data: res } = await this.$http.get('/api/index/apidata')
      this.logoUlr = res.data.logo
      let sy_info = {
        logo: res.data.logo,
        beian: res.data.beian
      }
      window.sessionStorage.setItem('sy_info', JSON.stringify(sy_info))
    },
    async queryMenu() {
      const { data: res } = await this.$http.get('api/index/getcate')
      if (res.code) {
        this.cateList = res.data
        this.queryProduct(this.cateList[0].id)
      }
    },
    async queryProduct(id) {
      this.productList = []
      this.loading = true
      let params = new URLSearchParams()
      params.append('cate_id', id)
      const { data: res } = await this.$http.post(
        'api/index/getproduct',
        params
      )
      if (res.code) {
        this.productList = res.data
        this.loading = false
        if (res.data.length) {
          this.active = id + '-' + this.productList[0].product_id
        }
      }
    },
    // 获取header数据
    async queryList() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: '/api/page/nav',
        data: param
      })
      JSON.stringify(res.data) !== []
        ? (this.headerList = res.data)
        : (this.headerList = {})
    },
    go(id) {
      this.$router.push('/quoteprice/content?id=' + id)
    },
    exit() {
      window.localStorage.clear()
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="less" scoped>
.el-container {
  height: auto;
  min-height: 100%;
  width: 100%;
  min-width: 100%;
}
.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  line-height: 50px;
  width: 100%;
  background: #fff;
  div {
    display: flex;
    align-items: center;
    img {
      margin-left: 15px;
      width: 83px;
    }
  }
}
.el-aside {
  min-height: 875px;
  overflow-x: hidden;
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 100%;
  }
}
.el-main {
  background-color: #eee;
}

.navitems-group {
  position: absolute;
  top: 20px;
  left: 180px;
  ul {
    li {
      float: left;
      width: 95px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      a {
        color: #333;
        font-size: 16px;
      }
    }
    .last-navitems {
      width: 160px;
      position: relative;
    }
    li:hover a {
      color: #a77c5a;
    }
    .drap_down {
      display: none;
      z-index: 999;
      position: absolute;
      top: 40px;
      right: -22px;
      width: 190px;
      height: 265px;
      background: #fff;
      ul {
        width: 100%;
        li {
          width: 100%;
          height: 32px;
          line-height: 32px;
          a {
            font-size: 14px;
            color: #666;
            display: flex;
            align-items: center;
            justify-content: center;
            span {
              display: inline-block;
              width: 16px;
              height: 14px;
              margin-right: 8px;
            }
            img {
              margin-right: 8px;
            }
          }
        }
        li:hover {
          background-color: #edfff6;
        }
        li:hover a {
          color: #a77c5a;
        }
      }
      .drap_li_first {
        margin-top: 9px;
      }
    }
  }
}
</style>